module.exports = __webpack_public_path__ + "media/images/icons/outlined/folder-add-4e6a2c2485b3bd2919889a11ebf7bb88.svg";